import React, { useState, useEffect } from "react";

import {
  Form,
  Input,
  Button,
  message,
  Alert,
  Row,
  Col,
  Space,
  Drawer,
} from "antd";

import { FormOutlined, ExclamationCircleOutlined } from "@ant-design/icons";

import { Http } from "../../Http";
import queryString from "query-string";

import Album from "../../component/Album.js";
import Thumb from "../../component/Thumb.js";
import Editor from "../../component/Editor.js";

import zlxz from "../../images/zlxz.png";

import styles from "./ProductSave.module.less";

const msg = [
  `系统会自动检测敏感词，若无敏感词，就会直接发布，否则需要人工审核！`,
  `价格、物流费用、计量单位的默认值由您在品牌设置那里填写的默认值生成`,
];

function ProductSave({ navigate, location, brand }) {
  const { state } = location;
  const { data, search, pagination } = state;

  const [submit, setSubmit] = useState(false);
  const [visible, setVisible] = useState(false);
  const [album, setAlbum] = useState({
    visible: false,
    width: 800,
    limit: 1,
    field: "",
  });

  const [form] = Form.useForm();

  const onPerfect = () => {
    navigate("../../brand");
  };

  const onBack = () => {
    navigate("../", { state: { search, pagination } });
  };

  const UnitTips = () => {
    let tips = [...msg];
    if (data?.banMsg) {
      tips.push(data.banMsg);
    }
    if (data?.reviewMsg) {
      tips.push(data.reviewMsg);
    }
    return (
      <div className={styles.tips}>
        <Row>
          <Col offset={4} span={20}>
            <Alert
              showIcon
              icon={<ExclamationCircleOutlined />}
              message={tips.map((v, k) => (
                <div key={k}>
                  {k + 1} . {v}
                </div>
              ))}
              type="warning"
            />
          </Col>
        </Row>
      </div>
    );
  };

  const onUploadOk = (value) => {
    setAlbum({ ...album, visible: false });
    form.setFieldsValue({ thumb: value[0] });
  };

  const onFinish = async (values) => {
    setSubmit(true);
    values.brandId = brand.id;
    if (data) {
      values = { ...data, ...values };
    }
    let para = queryString.stringify(values);
    try {
      let parsed = await Http.post(`product/save`, {
        body: new URLSearchParams(para),
      }).json();
      if (parsed.state === "ok") {
        await message.success(parsed.message ? parsed.message : "提交成功");
        onBack();
      } else {
        await message.warn(parsed.message ? parsed.message : "提交失败");
      }
    } catch (error) {
      await message.error("接口调用错误, 错误原因:" + error.message);
    } finally {
      setSubmit(false);
    }
  };

  useEffect(() => {
    if (data) {
      form.setFieldsValue(data);
    } else {
      if (brand) {
        form.setFieldsValue({
          price: Math.floor(
            Math.random() * (brand.maxPrice - brand.minPrice) + brand.minPrice
          ),
          express: brand.express,
          unit: brand.unit,
        });
      }
    }
  }, [data]);

  return (
    <div className={styles.ProductSave}>
      <div className={styles.header}>
        <div className={styles.headerLeft}>
          <div className={styles.title}>
            <FormOutlined style={{ fontSize: 18, color: "#1890ff" }} />
            <i>{data ? "产品编辑" : "新增产品"}</i>
          </div>
        </div>
        <div className={styles.headerRight}></div>
      </div>
      <div className={styles.content}>
        <div className={styles.wrap}>
          <UnitTips />
          <Form
            labelCol={{ span: 4 }}
            wrapperCol={{ span: 20 }}
            form={form}
            onFinish={onFinish}
          >
            <Form.Item
              name="name"
              label="名称"
              rules={[{ required: true, message: "请输入名称!" }]}
            >
              <Input
                placeholder="请输入名称，写作方法点击右侧警示图标 ->>"
                suffix={
                  <ExclamationCircleOutlined
                    style={{ color: "#faad14", cursor: "pointer" }}
                    onClick={() => setVisible(true)}
                  />
                }
              />
            </Form.Item>
            <Form.Item
              label="价格"
              name="price"
              rules={[{ required: true, message: "请输入价格" }]}
            >
              <Input suffix="￥" type="number" />
            </Form.Item>
            <Form.Item
              label="物流费用"
              name="express"
              rules={[{ required: true, message: "请输入物流费用" }]}
            >
              <Input placeholder="提示：例如包邮、上门自提、货到付款或面议..." />
            </Form.Item>
            <Form.Item
              label="计量单位"
              name="unit"
              rules={[{ required: true, message: "请输入计量单位" }]}
            >
              <Input placeholder="提示：例如个、套、件或吨..." />
            </Form.Item>
            <Form.Item
              label="关键词"
              name="keyword"
              rules={[{ required: true, message: "请输入关键词" }]}
            >
              <Input placeholder="请输入关键词" />
            </Form.Item>
            <Form.Item
              label="简介"
              rules={[{ required: true, message: "请输入简介" }]}
              name="description"
            >
              <Input.TextArea placeholder="简介" rows={3} />
            </Form.Item>
            <Form.Item
              label="内容"
              rules={[{ required: true, message: "请输入内容" }]}
              name="content"
            >
              <Editor />
            </Form.Item>
            <Form.Item
              label="缩略图"
              name="thumb"
              rules={[{ required: true, message: "请输入缩略图" }]}
            >
              <Thumb
                onClick={() =>
                  setAlbum({
                    visible: true,
                    width: 800,
                    limit: 1,
                    field: "thumb",
                  })
                }
              />
            </Form.Item>
            <Form.Item wrapperCol={{ offset: 4 }}>
              <Space>
                <Button
                  type="primary"
                  disabled={submit}
                  loading={submit}
                  htmlType="submit"
                >
                  提交
                </Button>
                <Button htmlType="button" onClick={onBack}>
                  返回
                </Button>
              </Space>
            </Form.Item>
          </Form>
          {brand?.status == 1 ? (
            <div className={styles.introMask}>
              <Alert
                message="请先完善基本信息！再来录入, 点我进行完善"
                type="warning"
                showIcon
                onClick={() => {
                  onPerfect();
                }}
              />
            </div>
          ) : null}
        </div>
        <div className={styles.adv}>
          <a href="https://sso.chinaqyz.com/shop?active=2" target="_blank">
            <img src={zlxz} alt="智能写作" />
          </a>
        </div>
      </div>
      <Album
        visible={album.visible}
        width={album.width}
        limit={album.limit}
        brand={brand?.id}
        onOk={onUploadOk}
        onCancel={() => setAlbum({ ...album, visible: false })}
      />
      <Drawer
        title="优质产品信息标题写作秘籍"
        placement="right"
        width={600}
        onClose={() => setVisible(false)}
        visible={visible}
      >
        <div className={styles.productWriting}>
          <h2>发布信息的规则：如何填写优质的产品信息标题？</h2>
          <p>
            我们应该怎样做才能把自己的网站发到百度第一页，一天发几十条信息都不管用就是上不了百度前两页怎么办？
          </p>
          <p>
            其实信息的发布都是有技巧性的，只有掌握了这些技巧才能使我们的信息被收录、拥有更好的排名；下面就举一例子让朋友们能够更好的掌握信息发布技巧。
          </p>
          <p>
            首先，网站的选择确实比较重要，发一个两个网站肯定没有效果的，所以我们特推出B2B联盟站，让您一键发布约200家平台；
          </p>
          <p>其次，学会写标题，这点大家应该都有所了解。</p>
          <p>
            标题其实可以理解成内容的精炼的描述：对于收录来说，我觉得标题能够独一无二就可以了（要向收录引擎表达的意思是：我是稀缺的）！
          </p>
          <p>
            对于关键词排名来说，应该尽可能匹配关键词，对于用户来说，那就是需要吸引力了，有点击，有阅读百度才会知道这是好的内容；信息发布，说简单也很简单，说难也有些门道的，不是一句话两句话可以说的清楚的，下面根据用户的一些疑问做出的一些整理，希望对大家有用：
          </p>
          <h2>※一些写标题的方法：</h2>
          <p>(1)格式：主关键词+长尾关键词</p>
          <p>
            比如要优化的目标关键词是“APP培训、APP实战培训、APP学习、APP教程、APP免费培训、免费APP教程、APP开发”那么标题就可以写成APP培训_梦想APP实战培训
            提供免费学习SEO教程，这样写就突出了关键词“APP培训”的重要性，后面的梦想APP实战培训是对前面的关键词APP培训的强调和起到品牌作用，接着“提供免费学习APP教程”吸引眼球，提供点击。
          </p>
          <p>完全的分词匹配：APP培训、APP实战培训、学习APP、APP教程、APP实战</p>
          <p>(2)格式：关键词+关键词…+品牌</p>
          <p>
            例子：APP培训|APP优质培训|APP实战培训-梦想APP培训教程网，整个标题都是特定的关键词，相对其他标题来说，特定关键词比较容易获得排名，但是可读性没那么高，设计不好还会影响点击率。使用”|”竖线分隔是目前百度搜索引擎最好的多个关键词匹配方式。
          </p>
          <p>(3)格式：品牌+关键词</p>
          <p>
            举例：梦想APP培训_提供专业APP培训，免费APP教程，APP学习交流平台。前面部分特指关键词“APP培训”，后面强调培训的同时，增加APP教程和APP学习等主要关键词，可读性就会比较强。
          </p>
          <p>(4)格式：关键词+品牌|修饰词</p>
          <p>
            举例：APP培训_梦想APP培训|APP培训机构，免费APP教程，APP学习交流平台。前面部分特指关键词“APP培训”，后面强调培训的同时，增加APP教程和APP学习等主要关键词，可读性就会比较强。
          </p>
          <p>
            再次，内容要新颖，要有差异化，除了新颖、差异化，最重要的一点是，内容必须以产品的实际情况相符，不要天马行空，为了新颖而忽略真实。
          </p>
          <h2>※信息内容需要注意的事项：</h2>
          <p>
            一条信息的质量优劣，主要是看信息内容，内容不行，标题写的再好也枉然，最多能够得上“标题党”的荣誉称号。而信息的质量也直接关系到信息的收录，信息的排名，甚至是整个网站的收录排名效果，一个有大量优质信息的网站，其收录排名肯定会很有利。那么，怎么样把握好信息的质量关呢？
          </p>
          <p>
            1、信息内容与信息标题相符。标题是什么产品，信息内容中就详细的介绍什么产品。
          </p>
          <p>
            2、信息内容应该包含哪些？在B2B信息中，信息的内容应该包含产品的大概介绍，产品型号、参数，产品功能等产品详情，最好是附上1-6张图片，图文并茂。
          </p>
          <p>
            3、信息内容中应该有相关的售后事项补充，要能让用户感受到自己的真诚，这样可以为之后的询盘增加成功率。
          </p>
          <p>
            还有，关键词布局也十分重要，一个信息页面，关键词的密度对排名的影响是很大的，所以合理的布局关键词也是获得好排名的关键因素。
          </p>
          <h2>※关键词布局注意事项：</h2>
          <p>
            一.关键词出现在文章前30个字中非常重要，就像写论文一样，最好开始就让人家知道你的观点，毕竟搜索引擎也是按照人的思维去阅读网页内容的。一定要阅读起来自然。
          </p>
          <p>二.关键词的密度：</p>
          <p>
            最佳的是占内容的2%-8%，不过也不要太注重这个了，自然书写就可以了。最好就是开头、中间、左右两边和底部都要合理出现关键词，至少出现一次，中间可以多出现几次。
          </p>
          <p>
            三.在内容中插入同义词：涂料你写成油漆
            搜索引擎也是默认信息和标题相关的.
          </p>
          <p>
            四.不要大量堆砌关键词，最好和标题完全一样的句子，最多就在内容中出现3次。
          </p>
          <p>
            最后要说的是，通过一些外部手段推广以及日常维护的工作来提升信息页面权重，比如网站内的广告竞价、关键词竞价排名、各种sns平台的分享、相同行业平台网站的外链等手段提高页面权重、提升排名。
          </p>
          <h2>※常用的外部推广手段：</h2>
          <p>网站关键词竞价已及广告竞价都可以使信息有更好的排名。</p>
          <p>
            分享：在我们的商铺里面都有一个分享的按钮，可以分享到百度收藏、QQ书签、开心网、人人网、新浪微博、腾讯微博等各大sns社区分享平台，这样既可以为信息增加外链，同时也是增加信息流量的入口，对收录等都有一定的作用，可以好好的利用这个既方便又简单的方法。
          </p>
          <h2> 外链： </h2>
          <p>
            一，商铺友情链接，商友之间互相做友情链接，促进彼此之间的流量转换，同时也让搜索引擎蜘蛛可以通过友情链接互相抓取收录帖子；
          </p>
          <p>
            二，论坛推广，合理特别要提出的是黄页社区里默认的签名是带上黄页内的商铺的，所以每一次回帖，发帖都能给商铺带上链接，从而为商铺提高权重，除此之外，当然可以到其他论坛博客去发布自己商铺的外链，把其他地方的流量引过来，也可以打通更多搜索引擎蜘蛛通往你商铺的通道，从而促进收录效果。
          </p>
          <h2>维护： </h2>
          <p>
            1、日常更新。每一个网站注册的帐号都需要维护，只有经常维护的帐号才会得到搜索引擎的信赖，才更能取得更好的收录排名效果。所以，每个网站注册的帐号，不需要一次性发布大量的信息，需要的是，每日或者经常有信息增加这样来维持在这个平台上面的商铺有更新度，获得搜索引擎的喜爱。
          </p>
          <p>
            2、旧信息刷新。旧的信息也需要经常刷新，很久没收录或没排名的信息及时修改。刷新信息是现在在使用分类信息网站的用户用的最好的一步了，每日都有大量的用户到网站去刷新久的信息。
          </p>
          <p>
            3、观察信息的效果。发布信息之后还需要观察信息收录排名状况，根据观察结果总结出什么样的信息有利于收录，怎么样发的信息排名好，从而修改不收录效果差的信息以便能让其更快收录，还可以为之后发布信息做参考，让以后少走弯路，少发垃圾无效果信息。在观察这一步，还可以总结出哪些平台是你使用的比较好的，效果比较明显的，然后在今后的工作中，就特别着重的去对待这些效果好的平台，减少去效果差的平台的时间，让时间利用的更加充分。
          </p>

          <h2>禁限售行业特别提醒：</h2>
          <p>
            （1）不得刊登包含金融（现货、白银、直播室、原油期货）、医疗、保健食品、微商、私服、游戏、赌博、色情、侦探、代孕、时时彩、彩票等敏感字眼的内容。
          </p>
          <p>
            （2）文章模板和标题不得使用百度标题（例如百度-百科、百度-知道之类）
          </p>
          <p>
            （3）不得刊登竞争对手的负面消息，不得发布产品品牌词（例如：京东、淘宝）
          </p>
          <p>（4）不得涉及政治、不健康的内容</p>
        </div>
      </Drawer>
    </div>
  );
}

export default ProductSave;
